export const GET_PROPERTY_LIST = 'GET_PROPERTY_LIST';
export const GET_PROPERTY_LIST_START = 'GET_PROPERTY_LIST_START';
export const GET_PROPERTY_LIST_SUCCESS = 'GET_PROPERTY_LIST_SUCCESS';
export const GET_PROPERTY_LIST_FAIL = 'GET_PROPERTY_LIST_FAIL';
export const CREATE_PROPERTY_START = 'CREATE_PROPERTY_START';
export const CREATE_PROPERTY_SUCCESS = 'CREATE_PROPERTY_SUCCESS';
export const CREATE_PROPERTY_FAIL = 'CREATE_PROPERTY_FAIL';
export const CREATE_PROPERTY = 'CREATE_PROPERTY';
export const MINT_PROPERTY = 'MINT_PROPERTY';
export const MINT_PROPERTY_SUCCESS = 'MINT_PROPERTY_SUCCESS';
export const MINT_PROPERTY_FAIL = 'MINT_PROPERTY_FAIL';
export const MINT_PROPERTY_START = 'MINT_PROPERTY_START';
export const PUT_ON_SALE = 'PUT_ON_SALE';
export const PUT_ON_SALE_SUCCESS = 'PUT_ON_SALE_SUCCESS';
export const PUT_ON_SALE_FAIL = 'PUT_ON_SALE_FAIL';
export const PUT_ON_SALE_START = 'PUT_ON_SALE_START';
export const BUY_EQUITY = 'BUY_EQUITY';

export const DELETE_PROPERTY = 'DELETE_PROPERTY';
export const DELETE_PROPERTY_START = 'DELETE_PROPERTY_START';
export const DELETE_PROPERTY_SUCCESS = 'DELETE_PROPERTY_SUCCESS';
export const DELETE_PROPERTY_FAIL = 'DELETE_PROPERTY_FAIL';
export const TOGGLE_PROPERTY_HIDE = 'TOGGLE_PROPERTY_HIDE';
export const TOGGLE_PROPERTY_HIDE_START = 'TOGGLE_PROPERTY_HIDE_START';
export const TOGGLE_PROPERTY_HIDE_SUCCESS = 'TOGGLE_PROPERTY_HIDE_SUCCESS';
export const TOGGLE_PROPERTY_HIDE_FAIL = 'TOGGLE_PROPERTY_HIDE_FAIL';
export const UPDATE_PROPERTY_STATUS = 'UPDATE_PROPERTY_STATUS';
export const UPDATE_PROPERTY_STATUS_START = 'UPDATE_PROPERTY_STATUS_START';
export const UPDATE_PROPERTY_STATUS_SUCCESS = 'UPDATE_PROPERTY_STATUS_SUCCESS';
export const UPDATE_PROPERTY_STATUS_FAIL = 'UPDATE_PROPERTY_STATUS_FAIL';
export const DELETE_PROPERTY_ADDITIONAL_DOCUMENT = 'DELETE_PROPERTY_ADDITIONAL_DOCUMENT';
export const DELETE_PROPERTY_ADDITIONAL_DOCUMENT_START = 'DELETE_PROPERTY_ADDITIONAL_DOCUMENT_START';
export const DELETE_PROPERTY_ADDITIONAL_DOCUMENT_SUCCESS = 'DELETE_PROPERTY_ADDITIONAL_DOCUMENT_SUCCESS';
export const DELETE_PROPERTY_ADDITIONAL_DOCUMENT_FAIL = 'DELETE_PROPERTY_ADDITIONAL_DOCUMENT_FAIL';
export const ADD_PROPERTY_ADDITIONAL_DOCUMENT = 'ADD_PROPERTY_ADDITIONAL_DOCUMENT';
export const ADD_PROPERTY_ADDITIONAL_DOCUMENT_START = 'ADD_PROPERTY_ADDITIONAL_DOCUMENT_START';
export const ADD_PROPERTY_ADDITIONAL_DOCUMENT_SUCCESS = 'ADD_PROPERTY_ADDITIONAL_DOCUMENT_SUCCESS';
export const ADD_PROPERTY_ADDITIONAL_DOCUMENT_FAIL = 'ADD_PROPERTY_ADDITIONAL_DOCUMENT_FAIL';